import React, { ReactNode } from "react";
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()({
    root: {
        marginBottom: "20px",
        display: "flex",
        alignItems: "center",
    },
    elementIcon: {
        paddingRight: "10px",
    },
});

interface CodeValidationResultWithIconProps {
    icon: ReactNode;
    children: ReactNode;
}

export function CodeValidationResultWithIcon(
    props: CodeValidationResultWithIconProps
) {
    const { icon, children } = props;
    const { classes } = useStyles();

    return (
        <div className={classes.root} data-cy="validationResult">
            <div className={classes.elementIcon}>{icon}</div>

            <div>{children}</div>
        </div>
    );
}
